var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreatedTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7062 9.01875L19.9813 2.29375C19.7938 2.10625 19.5406 2 19.275 2H6C5.44687 2 5 2.44687 5 3V29C5 29.5531 5.44687 30 6 30H26C26.5531 30 27 29.5531 27 29V9.72812C27 9.4625 26.8937 9.20625 26.7062 9.01875ZM24.6938 10.1875H18.8125V4.30625L24.6938 10.1875ZM24.75 27.75H7.25V4.25H16.6875V11C16.6875 11.3481 16.8258 11.6819 17.0719 11.9281C17.3181 12.1742 17.6519 12.3125 18 12.3125H24.75V27.75ZM17 14.75C17 14.6125 16.8875 14.5 16.75 14.5H15.25C15.1125 14.5 15 14.6125 15 14.75V18.125H11.625C11.4875 18.125 11.375 18.2375 11.375 18.375V19.875C11.375 20.0125 11.4875 20.125 11.625 20.125H15V23.5C15 23.6375 15.1125 23.75 15.25 23.75H16.75C16.8875 23.75 17 23.6375 17 23.5V20.125H20.375C20.5125 20.125 20.625 20.0125 20.625 19.875V18.375C20.625 18.2375 20.5125 18.125 20.375 18.125H17V14.75Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedTicket);
export default __webpack_public_path__ + "static/media/createdTicket.6ce838c7acc0baa92b940dbce47e6f09.svg";
export { ForwardRef as ReactComponent };